import axios from 'axios'

axios.interceptors.response.use(
    config => {
      config.headers = "Access-Control-Allow-Origin:*";
      return config;
    },
    error => Promise.reject(error)
  );
